export default __webpack_public_path__ + "static/media/photo--lg--82.94fba8a8.jpg";